import React, { Component } from "react";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";

class BsyTagList extends Component {
  isArray = (o) => {
    return Object.prototype.toString.call(o) === "[object Array]";
  };

  render() {
    const { header, data, customCls } = this.props;

    const constData = BsyUtils.isArray(data)
      ? data.filter((e) => e)
      : data
      ? [data]
      : [];

    const element = constData.map((res) => {
      if (!header || !header.items) {
        return {
          value: res,
          text: res,
          sytle: { color: "#333", background: "#f5f6f7" },
        };
      }
      const valitems = header.items.filter((item) => {
        return item.value === res;
      });
      if (valitems.length) {
        return {
          ...valitems[0],
          sytle: {
            background: valitems[0].color,
            border: "1px solid " + res.color,
          },
        };
      }
      return {
        value: res,
        text: res,
        sytle: { color: "#333", background: "#f5f6f7" },
      };
    });

    return (
      <div className={"BsyTagList " + (customCls ? customCls : "")}>
        {element.map((res, index) => {
          return (
            <div style={res.sytle} key={`data-${index}`} className="bsy-text-tag middle multi-line">
              {res.value}
            </div>
          );
        })}
      </div>
    );
  }
}

export default BsyTagList;
